module.exports = __webpack_public_path__ + "img/地黄.d965ef1f.jpg";